// NOTE on link URLs:
// - Shop links use the domestic (India) Shopify store domain directly.
// - All other links are RELATIVE paths (no domain) so they stay on the current
//   environment (staging stays on staging, production stays on production).
const data = {
  "brand": {
    "name": "shyft",
    "description": "Minimal ingredients. Maximum impact. Built for athletes who demand transparency and performance."
  },
  "sections": [
    {
      "title": "Shop",
      "links": [
        { "label": "Plant Protein Isolate", "url": "https://shop.betheshyft.com/collections/plant-protein-isolate/" },
        { "label": "Electrolytes", "url": "https://shop.betheshyft.com/collections/electrolytes/" },
        { "label": "Fermented Yeast Protein", "url": "https://shop.betheshyft.com/collections/fermented-yeast-protein/" },
        { "label": "All Products", "url": "https://shop.betheshyft.com/collections/all/" }
      ]
    },
    {
      "title": "Learn",
      "links": [
        { "label": "Blog", "url": "https://betheshyft.com/healthwatch/?utm_source=shyft_website&utm_medium=shyft_website_link&adset_name=website_link" },
        { "label": "FAQs", "url": "/faqs" },
        { "label": "Reviews", "url": "/" }
      ]
    },
    {
      "title": "Company",
      "links": [
        { "label": "About", "url": "/" },
        { "label": "Contact", "url": "/contact-us/" },
        { "label": "Privacy", "url": "/privacy-policy/?utm_source=shyft_website&utm_medium=shyft_website_link&adset_name=website_link" },
        { "label": "Terms", "url": "/terms-condition/" }
      ]
    }
  ],
  "copyright": "© 2026 shyft. All rights reserved.",
  "tagline": "Made for athletes, by athletes"
}
export default data;
